import {Component, OnInit} from '@angular/core';
import {JobsDataService} from '../../../../modules/jobs/jobs-data.service';

@Component({
    selector: 'app-my-interviews',
    templateUrl: './my-interviews.component.html',
    styleUrls: ['./my-interviews.component.scss']
})

export class MyInterviewsComponent implements OnInit {
    interviews: any;
    interviewsLoaded = false;

    constructor(private jobsDataService: JobsDataService) {
    }

    ngOnInit() {
        this.jobsDataService.getMyInterviews().subscribe(res => {
            this.interviews = res;
            this.interviewsLoaded = true;
        });
    }
}
